import { render, staticRenderFns } from "./Registros-Estudante.vue?vue&type=template&id=1f4886e8&scoped=true&"
import script from "./Registros-Estudante.vue?vue&type=script&lang=js&"
export * from "./Registros-Estudante.vue?vue&type=script&lang=js&"
import style0 from "./Registros-Estudante.vue?vue&type=style&index=0&id=1f4886e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4886e8",
  null
  
)

export default component.exports